/** MEMORY_SWORD_TRAINING — the road south with 赵呈博, the sword lesson, the ship south-west. */
import type { DialogueData } from '@/core/types/contracts';
import { SPEAKER } from '../actors';
import { letter, linear, say } from './util';

export const ROAD_DIALOGUES: DialogueData[] = [
  linear('prologue-road-talk', [
    letter('我跟赵呈博长者一路上他跟我讲了很多东西，比如长阳城的繁华，比如见到皇上应该如何行礼。'),
    say(SPEAKER.zhao, '今年是1157年。'),
    say(SPEAKER.jiang, '1157年……'),
    letter('我才知道现在已经是1157年了。'),
    say(SPEAKER.zhao, '路还长。来，我教你剑术。'),
    letter('一路上赵长者真的就像老师一样教导着我，甚至教我剑术。'),
  ]),
  // The battle outcome changes exactly one line.
  linear('prologue-road-after-goal', [
    say(SPEAKER.zhao, '好，有长进。'),
  ]),
  linear('prologue-road-after-other', [
    say(SPEAKER.zhao, '无妨，慢慢来。'),
  ]),
  linear('prologue-road-ship', [
    letter('船一路西南方向行驶，天气越来越热。'),
    letter('离开的时候星塘还在结冰呢，这里却越来越热。'),
    say(SPEAKER.zhao, '离太阳越来越近。'),
  ]),
];
